import React from "react";
import { useNavigate } from "react-router-dom";
import "../../style/pages/categoriespage/alsoneed.css";

import rifle from "../../media3/categories/r1.png"
import knive from "../../media3/categories/k1.png"
import glove from "../../media3/categories/g1.png"
import cases from "../../media3/categories/k10.png"
import co1 from "../../media3/categories/co1.png"

// Dummy data for suggested items
const suggested = [
  {
    name: "AK-47 | SLALOM ON FIRE",
    img: rifle,
    price: "$61.00 - $122.00",
    path: "/items/AK-47%20%7C%20Slalom"
  },
  {
    name: "KARAMBIT SHARP | SLALOM",
    img: knive,
    price: "$61.00 - $122.00",
    path: "/items/Karambit%20%7C%20Slalom"
  },
  {
    name: "SPORT GLOVES | SLALOM",
    img: glove,
    price: "$61.00 - $122.00",
     path: "/items/Sport%20Gloves%20%7C%20Slalom"
  },
  {
    name: "KARAMBIT | KILL CONFIRMED",
    img: cases,
    price: "$61.00 - $122.00",
    path: "/items/Karambit%20%7C%20Kill%20Confirmed"
  },
  {
    name: "Dust Rifle 898 | Collection",
    img:co1,
    price: "$61.00 - $132.00",
     path: "/items/Dust%20II%20Collection%20%7C%20Slalom"
  },
];
// ...existing code...

// changed code
const AlsoNeed = () => {
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  };

  return (
    <div className="alsoneed-section">
      <div className="alsoneed-title">You Might Also Need</div>
      <div className="alsoneed-list">
        {suggested.map((item, idx) => (
          <div
            className="alsoneed-card"
            key={idx}
            role="button"
            tabIndex={0}
            onClick={() => handleCardClick(item.path)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleCardClick(item.path); }}
            style={{ cursor: "pointer" }}
          >
            <img src={item.img} alt={item.name} className="alsoneed-img" />
            <div className="alsoneed-name">{item.name}</div>
            <div className="alsoneed-price">{item.price}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AlsoNeed;